import * as types from 'store/modules/hres7de/mutation-types'
import hres7de from 'api/hres7de'
import stdtrtest from 'api/stdtrtest'
import swal from 'sweetalert'
import hres7deLabels from 'assets/labels/hres7de'
import stdtrtestLabels from 'assets/labels/stdtrtest'
import { hres7deMaxRowspan, hres7deColumns } from 'assets/columns/hres7de'
import configLabel from 'src/../config/label'
import axios from 'axios'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: {
      en: Object.assign(hres7deLabels.en, stdtrtestLabels.en),
      th: Object.assign(hres7deLabels.th, stdtrtestLabels.th)
    },
    maxRowspan: hres7deMaxRowspan,
    columns: hres7deColumns(),
    index: {
      total: 0,
      rows: []
    },
    indexSelected: {},
    detail: {
      tab1: {},
      tab2: {
        detail: {},
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      },
      tab3: {
        total: 0,
        rows: []
      },
      tab4: {}
    },
    detailTab1Popup: {
      detail: {},
      table1: {
        total: 0,
        rows: []
      },
      table4: {
        total: 0,
        rows: []
      }
    },
    detailTab3Selected: {},
    detailTab3Popup: {
      detail: {},
      table1: {
        total: 0,
        rows: []
      },
      table2: {
        total: 0,
        rows: []
      }
    }
  },
  getters: {
    [types.GET_HRES7DE_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES7DE_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES7DE_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRES7DE_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES7DE_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES7DE_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES7DE_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES7DE_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRES7DE_DETAIL_TAB1_POPUP] (state) {
      return state.detailTab1Popup
    },
    [types.GET_HRES7DE_DETAIL_TAB3_SELECTED] (state) {
      return state.detailTab3Selected
    },
    [types.GET_HRES7DE_DETAIL_TAB3_POPUP] (state) {
      return state.detailTab3Popup
    }
  },
  mutations: {
    [types.SET_HRES7DE_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES7DE_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES7DE_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailTab1PopupBtn1to3 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab1PopupBtn1to3, labels[keyLang])
        state.columns[keyLang].detailTab1PopupBtn4 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab1PopupBtn4, labels[keyLang])
        state.columns[keyLang].detailTab3 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab3, labels[keyLang])
      }
    },
    [types.SET_HRES7DE_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES7DE_INDEX] (state, index) {
      state.index = index
    },
    [types.SET_HRES7DE_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES7DE_DETAIL] (state, detail) {
      state.detail = detail
    },
    [types.SET_HRES7DE_DETAIL_TAB1_POPUP] (state, detailTab1Popup) {
      state.detailTab1Popup = detailTab1Popup
    },
    [types.SET_HRES7DE_DETAIL_TAB3_SELECTED] (state, detailTab3Selected) {
      state.detailTab3Selected = detailTab3Selected
    },
    [types.SET_HRES7DE_DETAIL_TAB3_POPUP] (state, detailTab3Popup) {
      state.detailTab3Popup = detailTab3Popup
    }
  },
  actions: {
    [types.TOGGLE_HRES7DE_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES7DE_INDEX_DISP, indexDisp)
      commit(types.SET_HRES7DE_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES7DE_COLUMNS_LABELS] ({ commit }) {
      axios.all([
        hres7de.getLabels(),
        stdtrtest.getLabels()
      ])
      .then(axios.spread(function (responseLabels, responseLabelsStdtrtest) {
        const dataHres7de = JSON.parse(responseLabels.request.response)
        const dataStdtrtest = JSON.parse(responseLabelsStdtrtest.request.response)
        let labels = {}
        labels.en = Object.assign(dataHres7de.labels.en, dataStdtrtest.labels.en)
        labels.th = Object.assign(dataHres7de.labels.th, dataStdtrtest.labels.th)
        commit(types.SET_HRES7DE_COLUMNS, labels)
        commit(types.SET_HRES7DE_LABELS, labels)
      }))
      .catch((error) => {
        let message = error
        if (error.response) {
          const data = error.response.data
          message = data.response
        }
        swal({
          title: '', text: message, html: true, type: 'error'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      })
    },
    [types.RECEIVED_HRES7DE_INDEX] ({ commit }, searchParams) {
      hres7de.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES7DE_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRES7DE_INDEX, objData)
        })
    },
    [types.RECEIVED_HRES7DE_DETAIL] ({ commit }, searchParams) {
      hres7de.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES7DE_DETAIL, data)
        })
        .catch((response) => {
          const data = response.response.data
          swal({
            title: '', text: data.response, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          commit(types.SET_HRES7DE_INDEX_DISP, true)
          commit(types.SET_HRES7DE_DETAIL_DISP, false)
        })
    },
    [types.RECEIVED_HRES7DE_DETAIL_TAB1_POPUP] ({ commit }, popupParams) {
      hres7de.getDetailTab1Popup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES7DE_DETAIL_TAB1_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES7DE_DETAIL_TAB3_POPUP] ({ commit }, searchParams) {
      hres7de.getDetailTab3Popup(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES7DE_DETAIL_TAB3_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES7DE_TAB2_SAVE] ({ commit, dispatch }, { codempid, searchIndex, searchDetail, indexSelected, detailTab2 }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres7de.postSaveDetailTab2({ codempid, searchIndex, indexSelected, detailTab2 })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES7DE_INDEX, searchIndex)
              dispatch(types.RECEIVED_HRES7DE_DETAIL, searchDetail)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRES7DE_TAB3_POPUP_SAVE] ({ commit, dispatch }, { codempid, searchIndex, searchDetail, indexSelected, detailTab3 }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres7de.postSaveDetailTab3({ codempid, searchIndex, indexSelected, detailTab3 })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES7DE_INDEX, searchIndex)
              dispatch(types.RECEIVED_HRES7DE_DETAIL, searchDetail)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRES7DE_TAB4_SAVE] ({ commit, dispatch }, { searchIndex, searchDetail, detailTab4 }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres7de.postSaveDetailTab4({ searchIndex, detailTab4 })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES7DE_INDEX, searchIndex)
              dispatch(types.RECEIVED_HRES7DE_DETAIL, searchDetail)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres7de/index.js